/* Save the Dates — product page calculator (STDCalc namespace)
   Pricing tables: audited 1:1 against the live price-inquiry calculator
   (assets/quote-pricing.js → STD / ENVELOPES). Do not change.
   Look reuses product-studio-calc.css (.studio-calc / .scalc-* classes).
   Cart wiring mirrors product-studio-calc.js (deposit -> /cart/add.js -> /checkout). */
(function(){
  'use strict';

  // ── Tier helpers (q -> price-table index) ────────────────────────────────
  // Digital uses a 6-step ladder; presswork (min 30) and acrylic (min 10) use 5.
  function tierDigital(q){if(q<10)return 0;if(q<30)return 1;if(q<50)return 2;if(q<100)return 3;if(q<150)return 4;return 5;}
  function tierPress(q){if(q<30)return -1;if(q<50)return 0;if(q<80)return 1;if(q<100)return 2;if(q<150)return 3;return 4;}
  function tierAcrylic(q){if(q<10)return -1;if(q<30)return 0;if(q<50)return 1;if(q<100)return 2;if(q<150)return 3;return 4;}

  // ── Pricing tables (do not modify) ────────────────────────────────────────
  const STD = {
    digital: { base: { '100x150':[11.00,10.00,8.50,7.50,7.00,5.50] },
      addons: { foilSingle:[6.00,6.00,6.00,5.50,5.50,5.00], duplexing:[7.00,5.75,5.00,4.80,4.60,3.50], cutToShape:[2.50,2.50,2.50,2.00,2.00,2.00] } },
    acrylic: { base: { '100x150':[21.50,17.50,17.00,16.50,13.80], '70x70':[13.00,10.90,9.20,8.70,6.90] }, mirror: { '100x150':3.00, '70x70':1.50 } },
    letterpress: { base: { '100x150':[28.50,18.50,13.80,11.50,10.00] }, addons: { secondColour:6.00, hotFoil:11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } },
    hotfoil: { base: { '100x150':[32.00,27.50,22.00,19.00,15.50] }, addons: { digital:1.50, letterpress:8.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } },
    embossed: { base: { '100x150':[53.00,35.50,27.60,23.50,19.50] }, addons: { letterpress:8.00, hotFoil:11.00, cutToShape:[2.50,2.50,2.50,2.00,2.00] } }
  };
  const ENVELOPES = { upgrade: { 'C6':0.90 }, printing:2.50, liner:4.50, embossedStamp:195.00, embossedStamping:4.00, waxStampCustom:195.00, waxAdhesive:5.50, waxStick:9.50 };
  const RIBBON = { satin:7, velvet:9, silk:12 };

  // Icons (Shopify CDN URLs — same assets the Studio calc uses)
  const ICON = {
    liner:   'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_-_liners.webp?v=1757232086',
    emboss:  'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_envelope_embbosing_49f5f437-0ed3-483e-8651-392bd2d9679b.webp?v=1757233214',
    sticker: 'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_stickers.webp?v=1757232206',
    wax:     'https://cdn.shopify.com/s/files/1/0700/1669/6516/files/Felicitations_-_icons_wax.webp?v=1757232209'
  };

  const STEPS = ['Quantity','Design','Print & Finishes','Envelopes','Review'];
  const ROMAN = ['I','II','III','IV','V'];
  const TIER_LABEL = { suite:'Studio Collection', indiv:'Tailored Touch' };

  // Finishing-touch checkbox keys, grouped by the print style/method they belong
  // to. Switching style/method clears the groups that no longer apply so a tick
  // set under one style can't silently re-apply under another.
  const FIN_GROUPS = {
    digital:     ['foilS','duplex'],
    letterpress: ['lp2pms','lpFoil'],
    hotfoil:     ['hfDigital','hfLp'],
    embossed:    ['emLp','emHf'],
    acrylic:     ['acMirror']
  };
  const ALL_FIN_KEYS = Object.values(FIN_GROUPS).reduce((a,b)=>a.concat(b),[]);

  // ── State ────────────────────────────────────────────────────────────────
  const state = {
    step:1, pay:'deposit', qty:0, tier:'suite', style:null, method:null, acSize:'100x150',
    ribbon:'satin', seal:'sticker', waxType:'adhesive', checks:{}
  };

  // Config injected from section settings (read once on init)
  const cfg = { designBase:100, deposit:100, tierUpcharge:50, depositVariantGid:'', fullVariantGid:'', tierAddonVariantGid:'',
    matchInvAmount:100, matchInvVariantGid:'', matchFullAmount:200, matchFullVariantGid:'',
    matchInvAmountTT:150, matchInvVariantGidTT:'', matchFullAmountTT:350, matchFullVariantGidTT:'',
    designName:'Save The Dates' };

  // Design fee depends on the chosen tier: Tailored Touch adds the upcharge.
  function designBaseFor(){ return cfg.designBase + (state.tier==='indiv' ? cfg.tierUpcharge : 0); }
  // Optional matching-design upsell (single choice): add matching invitations OR
  // full matching wedding stationery. The add-on amount + variant are TIER-AWARE —
  // Tailored Touch costs more. Studio Collection: +$100 / +$200 (deposit $200 / $300).
  // Tailored Touch:    +$150 / +$350 (deposit $300 / $500, on a $150 TT base).
  function matchInvAmt(){  return state.tier==='indiv' ? cfg.matchInvAmountTT  : cfg.matchInvAmount; }
  function matchFullAmt(){ return state.tier==='indiv' ? cfg.matchFullAmountTT : cfg.matchFullAmount; }
  function matchAmount(){ return state.checks.invDesign ? matchInvAmt() : (state.checks.fullDesign ? matchFullAmt() : 0); }
  function matchVariantGid(){
    if(state.checks.invDesign)  return state.tier==='indiv' ? cfg.matchInvVariantGidTT  : cfg.matchInvVariantGid;
    if(state.checks.fullDesign) return state.tier==='indiv' ? cfg.matchFullVariantGidTT : cfg.matchFullVariantGid;
    return '';
  }
  // Deposit collected at checkout: Tailored Touch is charged the upcharge upfront
  // (via a $50 add-on cart line), so the deposit becomes $150. The matching-design
  // upsell stacks on top.
  function effectiveDeposit(){ return cfg.deposit + (state.tier==='indiv' ? cfg.tierUpcharge : 0) + matchAmount(); }
  // Base deposit (without the matching-design upsell) — used for the live labels.
  function baseDeposit(){ return cfg.deposit + (state.tier==='indiv' ? cfg.tierUpcharge : 0); }
  function updateMatchLabels(){
    const base = baseDeposit();
    const pi = document.getElementById('p-invDesign');
    if(pi) pi.textContent = `+$${matchInvAmt()} · Design Fee becomes $${base + matchInvAmt()}`;
    const pf = document.getElementById('p-fullDesign');
    if(pf) pf.textContent = `+$${matchFullAmt()} · Design Fee becomes $${base + matchFullAmt()}`;
  }
  function updateDepositButton(){
    const depBtn = document.querySelector('[data-pay="deposit"]');
    if(depBtn && depBtn.firstChild) depBtn.firstChild.nodeValue = `Pay Design Fee · $${effectiveDeposit()}`;
  }

  // ── Persistence (localStorage) ─────────────────────────────────────────────
  const STD_STORAGE_KEY = 'felicitations_std_state';
  const STD_TTL_DAYS = 30;
  let stdSaveTimer = null;
  function stdSave(){
    clearTimeout(stdSaveTimer);
    stdSaveTimer = setTimeout(()=>{
      try { localStorage.setItem(STD_STORAGE_KEY, JSON.stringify({ ts: Date.now(), s: state })); } catch(e){}
    }, 400);
  }
  function stdLoad(){
    try {
      const raw = localStorage.getItem(STD_STORAGE_KEY);
      if(!raw) return null;
      const obj = JSON.parse(raw);
      if((Date.now() - obj.ts) / 86400000 > STD_TTL_DAYS){ localStorage.removeItem(STD_STORAGE_KEY); return null; }
      return { data: obj.s, ts: obj.ts };
    } catch(e){ return null; }
  }
  function stdHasMeaningful(){
    return !!(state.qty > 0 || state.style ||
              Object.keys(state.checks || {}).some(k => state.checks[k]));
  }
  function stdStartOver(){
    try { localStorage.removeItem(STD_STORAGE_KEY); } catch(e){}
    location.href = location.pathname;
  }
  function stdApplyRestoredUI(){
    const qi = $('qtyIn'); if(qi) qi.value = state.qty || '';
    document.querySelectorAll('[data-tier]').forEach(b => b.classList.toggle('on', b.dataset.tier === state.tier));
    document.querySelectorAll('[data-style]').forEach(b => b.classList.toggle('on', b.dataset.style === state.style));
    document.querySelectorAll('[data-method]').forEach(b => b.classList.toggle('on', b.dataset.method === state.method));
    document.querySelectorAll('[data-acsize]').forEach(b => b.classList.toggle('on', b.dataset.acsize === state.acSize));
    Object.keys(state.checks || {}).forEach(k => {
      if(!state.checks[k]) return;
      const cb = document.querySelector('[data-c="' + k + '"]'); if(cb) cb.checked = true;
      const tile = document.querySelector('[data-tile="' + k + '"]'); if(tile){ tile.classList.add('on'); tile.setAttribute('aria-pressed','true'); }
    });
    const addrSel = $('addrSel'); if(addrSel) addrSel.value = (state.checks && state.checks.envAddr) ? 1 : 0;
    document.querySelectorAll('[data-rb]').forEach(b => b.classList.toggle('on', b.dataset.rb === state.ribbon));
    document.querySelectorAll('[data-wt]').forEach(b => b.classList.toggle('on', b.dataset.wt === state.waxType));
    document.querySelectorAll('[data-seal]').forEach(b => { const on = b.dataset.seal === state.seal; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    const rt = $('ribbonType'); if(rt) rt.hidden = !(state.checks && state.checks.ribbon);
    const wt = $('waxType'); if(wt) wt.hidden = state.seal !== 'wax';
  }
  function stdShowWelcome(ts){
    const root = document.querySelector('.std-calc');
    if(!root || document.getElementById('std-welcome')) return;
    let dateStr = '';
    try { dateStr = new Date(ts).toLocaleDateString('en-AU', { day:'numeric', month:'long' }); } catch(e){}
    const bar = document.createElement('div');
    bar.id = 'std-welcome';
    bar.style.cssText = 'display:flex;align-items:center;gap:1rem;justify-content:center;flex-wrap:wrap;background:#faf7f3;border-bottom:1px solid #ece4d9;padding:14px 18px;color:#2a2520;font-size:.95rem;line-height:1.4';
    bar.innerHTML = '<span>Welcome back — we restored your selections' + (dateStr ? ' from <strong>' + dateStr + '</strong>' : '') + '.</span>' +
      '<a href="#" class="std-welcome-reset" style="color:#7a1c2e;text-decoration:underline;cursor:pointer">Start Over</a>' +
      '<a href="#" class="std-welcome-x" aria-label="Dismiss" style="color:#9a9a9a;text-decoration:none;font-size:1.3rem;line-height:1;cursor:pointer">&times;</a>';
    root.parentNode.insertBefore(bar, root);
    bar.querySelector('.std-welcome-reset').addEventListener('click', e => { e.preventDefault(); stdStartOver(); });
    bar.querySelector('.std-welcome-x').addEventListener('click', e => { e.preventDefault(); bar.remove(); });
  }

  // First render = initial page load — don't auto-scroll into the calc.
  let firstRender = true;

  // ── Helpers ──────────────────────────────────────────────────────────────
  const $ = id => document.getElementById(id);
  const fmt = n => '$' + (Math.round(n*100)/100).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});
  const fmt0 = n => '$' + Math.round(n).toLocaleString('en-AU');
  let lastTotal = 0;

  function minQty(){
    if(state.style==='presswork') return 30;
    if(state.style==='acrylic') return 10;
    return 1;
  }
  function acSizeLabel(s){ return {'100x150':'Standard (100×150)','70x70':'Petite (70×70)'}[s] || s; }
  function baseUnit(q){
    if(!q || !state.style) return 0;
    if(state.style==='digital'){ return STD.digital.base['100x150'][tierDigital(q)]; }
    if(state.style==='acrylic'){ const ta=tierAcrylic(q); return ta<0?0:STD.acrylic.base[state.acSize][ta]; }
    if(state.style==='presswork' && state.method){ const tp=tierPress(q); return tp<0?0:STD[state.method].base['100x150'][tp]; }
    return 0;
  }

  // ── Pricing line items ───────────────────────────────────────────────────
  function lines(){
    const s = state, out = [], q = s.qty, cc = s.checks;
    if(q>0) out.push([`Design — ${TIER_LABEL[s.tier]||'Studio Collection'} (base)`, designBaseFor(), 2]);
    if(cc.invDesign)  out.push(['Matching invitation design', matchInvAmt(), 5]);
    if(cc.fullDesign) out.push(['Full matching wedding stationery design', matchFullAmt(), 5]);
    if(q<=0) return out;
    const t = tierDigital(q), tp = tierPress(q), ta = tierAcrylic(q);
    if(!s.style) return out;

    if(s.style==='digital'){
      const ad = STD.digital.addons;
      out.push([`Fine digital save the date × ${q}`, STD.digital.base['100x150'][t]*q, 3]);
      if(cc.foilS)  out.push(['Signature flat foil (front)', ad.foilSingle[t]*q, 3]);
      if(cc.duplex) out.push(['Duplexing 600gsm', ad.duplexing[t]*q, 3]);
      if(cc.cut)    out.push(['Custom cut to shape', ad.cutToShape[t]*q, 3]);
    } else if(s.style==='acrylic'){
      if(ta<0){ out.push(['Acrylic requires min 10', 0, 3, true]); }
      else {
        const sz = s.acSize;
        out.push([`Acrylic save the date ${acSizeLabel(sz)} × ${q}`, STD.acrylic.base[sz][ta]*q, 3]);
        if(cc.acMirror) out.push(['Mirror acrylic upgrade', STD.acrylic.mirror[sz]*q, 3]);
      }
    } else if(s.style==='presswork' && tp>=0 && s.method){
      const pset = STD[s.method], L = {letterpress:'Letterpress', hotfoil:'Hot Foil', embossed:'Embossed'};
      out.push([`${L[s.method]} save the date × ${q}`, pset.base['100x150'][tp]*q, 3]);
      if(s.method==='letterpress'){ if(cc.lp2pms) out.push(['Second colour (2 PMS)', pset.addons.secondColour*q, 3]); if(cc.lpFoil) out.push(['Add hot foil', pset.addons.hotFoil*q, 3]); }
      else if(s.method==='hotfoil'){ if(cc.hfDigital) out.push(['Add digital print', pset.addons.digital*q, 3]); if(cc.hfLp) out.push(['Add letterpress (1 PMS)', pset.addons.letterpress*q, 3]); }
      else if(s.method==='embossed'){ if(cc.emLp) out.push(['Add letterpress (1 PMS)', pset.addons.letterpress*q, 3]); if(cc.emHf) out.push(['Add hot foil', pset.addons.hotFoil*q, 3]); }
      if(cc.cut) out.push(['Custom cut to shape', pset.addons.cutToShape[tp]*q, 3]);
    }

    if(cc.ribbon){ out.push(['Hand-tied ribbon — '+s.ribbon, (RIBBON[s.ribbon]||0)*q, 3]); }

    if(cc.envUp)    out.push(['Premium coloured envelope (C6)', ENVELOPES.upgrade['C6']*q, 4]);
    if(cc.envAddr)  out.push(['Guest & return addressing', ENVELOPES.printing*q, 4]);
    if(cc.envLiner) out.push(['Envelope liner', ENVELOPES.liner*q, 4]);
    if(cc.envEmb){ out.push(['Envelope embossing (one-off stamp)', ENVELOPES.embossedStamp, 4]); out.push(['Envelope embossing (per piece)', ENVELOPES.embossedStamping*q, 4]); }
    if(s.seal==='wax'){
      out.push(['Custom wax stamp (one-off)', ENVELOPES.waxStampCustom, 4]);
      if(s.waxType==='adhesive') out.push(['Adhesive wax seals', ENVELOPES.waxAdhesive*q, 4]);
      else out.push([`Wax sticks (DIY, ~${Math.ceil(q/7)} sticks)`, ENVELOPES.waxStick*Math.ceil(q/7), 4]);
    }
    return out;
  }

  // ── Qty + chips ──────────────────────────────────────────────────────────
  function onQty(v){ state.qty = Math.max(0, Math.min(500, parseInt(v,10)||0)); afterQtyChange(); }
  function bump(d){
    const base = state.qty || (60-d);
    state.qty = Math.max(0, Math.min(500, base+d));
    $('qtyIn').value = state.qty || '';
    afterQtyChange();
  }
  function pick(q){ state.qty = q; $('qtyIn').value = q; afterQtyChange(); }
  function afterQtyChange(){
    // If qty dropped below the selected style's minimum, unselect that style.
    if(state.style && state.qty>0 && state.qty<minQty()){
      state.style = null;
      state.method = null;
      document.querySelectorAll('[data-style], [data-method]').forEach(b=>b.classList.remove('on'));
      clearFinChecks([]);
    }
    refreshReveal(); updateQtyUI(); recalc(); validate();
  }
  function updateQtyUI(){
    const m = $('qtyMath'), q = state.qty;
    document.querySelectorAll('.scalc-chip').forEach(c=>c.classList.toggle('on', +c.dataset.q===q));
    if(!q){ m.innerHTML = '<span style="color:#b3aca5">Print pricing is added once you choose your print style and finishes.</span>'; return; }
    m.innerHTML = `<b>${q}</b> save the dates &nbsp;·&nbsp; pricing shown once you choose your finishes.`;
  }

  function clearFinChecks(keep){
    const keepSet = new Set();
    (keep||[]).forEach(g => (FIN_GROUPS[g]||[]).forEach(k=>keepSet.add(k)));
    ALL_FIN_KEYS.forEach(k=>{
      if(keepSet.has(k)) return;
      if(state.checks[k]){
        state.checks[k] = false;
        const el = document.querySelector(`[data-c="${k}"]`);
        if(el && el.type==='checkbox') el.checked = false;
      }
    });
  }

  // ── Price labels ─────────────────────────────────────────────────────────
  function refreshPrices(){
    const q = state.qty||100, t = tierDigital(q), tp = tierPress(q), ta = tierAcrylic(q);
    const set = (id,v)=>{ const e=$(id); if(e) e.textContent = v; };
    const taSafe = ta<0?0:ta, tpSafe = tp<0?0:tp;
    set('p-foilS','+'+fmt(STD.digital.addons.foilSingle[t])+'/ea');
    set('p-duplex','+'+fmt(STD.digital.addons.duplexing[t])+'/ea');
    set('p-lp2pms','+'+fmt(STD.letterpress.addons.secondColour)+'/ea');
    set('p-lpFoil','+'+fmt(STD.letterpress.addons.hotFoil)+'/ea');
    set('p-hfDigital','+'+fmt(STD.hotfoil.addons.digital)+'/ea');
    set('p-hfLp','+'+fmt(STD.hotfoil.addons.letterpress)+'/ea');
    set('p-emLp','+'+fmt(STD.embossed.addons.letterpress)+'/ea');
    set('p-emHf','+'+fmt(STD.embossed.addons.hotFoil)+'/ea');
    set('p-acMirror','+'+fmt(STD.acrylic.mirror[state.acSize||'100x150'])+'/ea');
    set('p-ribbon','from +'+fmt(RIBBON.satin)+'/ea');
    set('p-envUp','+'+fmt(ENVELOPES.upgrade['C6'])+'/ea');
    // Custom cut price depends on the current print style.
    let cutPer = STD.digital.addons.cutToShape[t];
    if(state.style==='presswork' && state.method && STD[state.method]) cutPer = STD[state.method].addons.cutToShape[tpSafe];
    set('p-cut','+'+fmt(cutPer)+'/ea');
    setTilePrice('liner','+'+fmt(ENVELOPES.liner)+'/ea');
    setTilePrice('emboss','$195 + '+fmt(ENVELOPES.embossedStamping)+'/ea');
  }
  function setTilePrice(key,v){ const e = document.querySelector(`[data-tileprice="${key}"]`); if(e) e.textContent = v; }

  // ── Reveal / disable logic for step 2 ────────────────────────────────────
  function refreshReveal(){
    const q = state.qty;
    $('methodGroup').hidden  = !(state.style==='presswork');
    $('acSizeGroup').hidden  = !(state.style==='acrylic');

    // Style buttons: always visible. Disable presswork (<30) / acrylic (<10).
    document.querySelectorAll('[data-style]').forEach(b=>{
      const s = b.dataset.style;
      let disabled = false;
      if(q > 0){
        if(s === 'presswork' && q < 30) disabled = true;
        if(s === 'acrylic'   && q < 10) disabled = true;
      }
      b.disabled = disabled;
      b.classList.toggle('on', state.style===s && !disabled);
    });

    const sh = $('printStyleHint');
    if(sh){
      const base = 'Fine flat print for speed. Luxury presswork for exquisite, textured results. Acrylic for a modern statement.';
      if(q===0) sh.innerHTML = base;
      else if(q<10) sh.innerHTML = base + '<br><em>Add more save the dates to unlock Acrylic (from 10) and Luxury Presswork (from 30).</em>';
      else if(q<30) sh.innerHTML = base + '<br><em>Add more save the dates to unlock Luxury Presswork (from 30).</em>';
      else sh.innerHTML = base;
    }

    // Finishing-touch groups: show only the one matching the current selection.
    $('finDigital').hidden = !(state.style==='digital');
    $('finLp').hidden      = !(state.style==='presswork' && state.method==='letterpress');
    $('finHf').hidden      = !(state.style==='presswork' && state.method==='hotfoil');
    $('finEm').hidden      = !(state.style==='presswork' && state.method==='embossed');
    $('finAcrylic').hidden = !(state.style==='acrylic');

    // Extras block shows once a style is chosen; custom cut hidden for acrylic
    // (acrylic save the dates have no cut-to-shape pricing).
    $('finishExtras').hidden = !state.style;
    const cutRow = $('cutRow');
    if(cutRow){
      const hideCut = !state.style || state.style==='acrylic';
      cutRow.hidden = hideCut;
      if(hideCut && state.checks.cut){ state.checks.cut = false; const cb = cutRow.querySelector('[data-c="cut"]'); if(cb) cb.checked = false; }
    }
    // Acrylic size buttons reflect state.
    document.querySelectorAll('[data-acsize]').forEach(b=>b.classList.toggle('on', b.dataset.acsize===state.acSize));
  }

  // ── Recalc + bottom bar + review ─────────────────────────────────────────
  // ── Design fee (scope-tiered, charged once via the shared cart helper) ──────
  function designTierKey(){ return state.tier==='indiv' ? 'TT' : 'SC'; }
  function designScopeKey(){ return state.checks.fullDesign ? 'full' : (state.checks.invDesign ? 'inv' : 'std'); }
  function priceTable(){ return (window.FelDesign && window.FelDesign.PRICE) || {SC:{std:100,inv:200,full:300},TT:{std:150,inv:300,full:500}}; }
  function designFeeAmt(){ return priceTable()[designTierKey()][designScopeKey()]; }
  // Production balance = everything except the design fee (print + envelopes; review steps 3 & 4).
  function printTotal(){ return lines().reduce(function(a,l){ return a + ((l[2]===3 || l[2]===4) ? l[1] : 0); }, 0); }

  function recalc(){
    refreshPrices();
    const ls = lines();
    const print = printTotal(), fee = designFeeAmt(), total = print + fee, last = state.step===STEPS.length;
    const amt = $('barAmt');
    if(last){
      $('barLbl').textContent = 'Due today';
      amt.textContent = fmt0(fee);
      $('barSub').textContent = '';
    } else {
      $('barLbl').textContent = (state.qty>0) ? `Total so far · ${state.qty} save the dates` : 'Total so far';
      amt.textContent = fmt0(total);
      $('barSub').textContent = (fee > 0) ? `Due Today: ${fmt0(fee)}` : '';
    }
    const nb = $('nextBtn'); if(nb) nb.style.display = '';
    // Step 1 uses the inline Continue; on review the bar shows "Due today $fee" + the Pay-deposit CTA.
    const bar = document.querySelector('.studio-calc-bar'); if(bar) bar.style.display = (state.step===1) ? 'none' : '';
    const barTot = document.querySelector('.studio-calc-bar .bar-total'); if(barTot) barTot.style.visibility = 'visible';
    if(total !== lastTotal){ amt.classList.remove('pulse'); void amt.offsetWidth; amt.classList.add('pulse'); lastTotal = total; }
    if(last) renderReview();
    stdSave();
  }

  function renderReview(){
    const r = $('rev'); if(!r) return; r.innerHTML = '';
    const mk = (tag,cls,html)=>{ const e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; };
    if(!state.qty || !state.style){ r.innerHTML = '<div class="rev-l"><span class="rl">Make your selections to see your save the dates.</span></div>'; return; }
    const ls = lines(), print = printTotal(), fee = designFeeAmt(), P = priceTable();
    const tier = designTierKey(), scope = designScopeKey();
    const tierLabel = tier==='TT' ? 'Tailored Touch' : 'Studio Collection';
    const scopeShort = {std:'Save the Dates', inv:'Invitations', full:'Full set'}[scope];

    // totals card
    const tot = mk('div','dc-sum');
    const row = (l,v,cls)=> mk('div','dc-sum-row'+(cls?' '+cls:''), '<span class="dc-sum-l">'+l+'</span><span class="dc-sum-v">'+v+'</span>');
    tot.appendChild(row('Estimated Production Balance', fmt(print)));
    const coverLbl = {std:'Save the Dates only', inv:'Invitations (Save the Dates included)', full:'Full wedding stationery'}[scope] || '';
    tot.appendChild(row('Design &amp; Curation Fee · '+tierLabel+(coverLbl?' · '+coverLbl:''), fmt(fee)));
    tot.appendChild(mk('hr','dc-sum-hr'));
    tot.appendChild(row('Total Suite Investment', fmt(print+fee)+' <span class="dc-sum-cur">AUD</span>', 'dc-sum-grand'));
    tot.appendChild(row('Due Today', fmt(fee)+' <span class="dc-sum-cur">AUD</span>', 'dc-sum-due'));
    tot.appendChild(row('Remaining Production Balance', fmt(print)+' <span class="dc-sum-cur">AUD</span> <span class="dc-sum-when">(Due upon final print approval)</span>', 'dc-sum-remain'));
    r.appendChild(tot);
    r.appendChild(mk('p','dc-sum-note','Your final production balance is only finalised and processed after you personally approve and sign off on your designs during the proofing phase.'));

    // collapsed itemised detail
    const accBtn = mk('button','dc-sum-toggle','<span class="dc-sum-chev" aria-hidden="true">›</span> Review Itemised Selection Detail'); accBtn.type='button';
    const detail = mk('div','dc-sum-detail'); detail.hidden = true;
    detail.appendChild(mk('div','rev-l','<span class="rl">Design · '+tierLabel+' ('+scopeShort+')</span><span class="rp">'+fmt(fee)+'</span>'));
    ls.forEach(([l,p,st])=>{ if(st===2||st===5) return; detail.appendChild(mk('div','rev-l','<span class="rl">'+l+' <button class="ed" data-goto="'+st+'">edit</button></span><span class="rp">'+fmt(p)+'</span>')); });
    detail.appendChild(mk('div','rev-l','<span class="rl" style="color:#6b6966;font-style:italic">Total estimated production</span><span class="rp" style="color:#6b6966">'+fmt(print)+'</span>'));
    accBtn.addEventListener('click', ()=>{ detail.hidden=!detail.hidden; accBtn.classList.toggle('open', !detail.hidden); });
    r.appendChild(accBtn); r.appendChild(detail);

    // add-ons (scope upsell — book more, one design fee)
    const ad = mk('div','dc-addons');
    ad.appendChild(mk('p','dc-addon-h','Complete your suite &amp; save'));
    const addon = (key,name,sub,priceTxt)=>{
      const on = state.checks[key];
      const lab = mk('label','dc-addon'+(on?' on':''), '<input type="checkbox"'+(on?' checked':'')+'><span class="dc-addon-txt"><span class="dc-addon-name">'+name+'</span><span class="dc-addon-sub">'+sub+'</span></span><span class="dc-addon-pr">'+priceTxt+'</span>');
      lab.querySelector('input').addEventListener('change', e=>{
        state.checks.invDesign=false; state.checks.fullDesign=false;
        if(e.target.checked) state.checks[key]=true;
        recalc(); validate();
      });
      return lab;
    };
    ad.appendChild(addon('invDesign','Add matching invitation design','Your Save the Dates stay included free — one cohesive design, charged once.', 'Design '+fmt0(P[tier].inv)));
    ad.appendChild(addon('fullDesign','Add the full wedding suite','Save the Dates + Invitations + On-the-day, designed together. Best value.', 'Design '+fmt0(P[tier].full)));
    r.appendChild(ad);

    // Design Journey
    const journey = mk('div','dc-journey');
    journey.appendChild(mk('p','dc-journey-h','Your design journey'));
    [['Secure Your Date','Your Design Fee secures your production slot in our studio calendar and officially begins your dedicated design phase.'],
     ['Digital Proofing &amp; Refinement','We perfect your typography, layout and details together over two rounds of revisions. Adjust quantities or finishes any time during this phase.'],
     ['Final Approval &amp; Production','Nothing goes to print without your final digital approval. Your remaining production balance is only processed once you sign off.']]
      .forEach((s,i)=> journey.appendChild(mk('div','dc-journey-step','<span class="dc-journey-num">'+(i+1)+'</span><span class="dc-journey-txt"><span class="dc-journey-t">Step '+(i+1)+': '+s[0]+'</span><span class="dc-journey-b">'+s[1]+'</span></span>')));
    r.appendChild(journey);

    r.querySelectorAll('button.ed[data-goto]').forEach(b=>b.addEventListener('click', ()=>goTo(+b.dataset.goto)));
  }

  // ── Scroll helpers ───────────────────────────────────────────────────────
  function scrollToNext(el){
    if(!el) return;
    setTimeout(()=>{
      const prog = document.querySelector('.std-calc .prog');
      const progH = prog && getComputedStyle(prog).position === 'sticky'
        ? prog.getBoundingClientRect().height : 0;
      const themeHeader = document.querySelector('header[is="sticky-header"], sticky-header, custom-header, .site-header.is-sticky, .header.is-sticky');
      const themeH = themeHeader ? themeHeader.getBoundingClientRect().height : 0;
      const off = progH + themeH + 20;
      const target = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - off);
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        try { window.lenis.scrollTo(target, { duration: 0.6 }); return; } catch(_){}
      }
      try { window.scrollTo({top: target, behavior:'smooth'}); }
      catch(_){ window.scrollTo(0, target); }
    }, 160);
  }
  function pressFin(){ return !$('finLp').hidden ? $('finLp') : (!$('finHf').hidden ? $('finHf') : $('finEm')); }

  function scrollToCalcTop(el){
    if (!el) return;
    const computeTarget = () => el.getBoundingClientRect().top + window.pageYOffset;
    const doScroll = () => {
      const target = computeTarget();
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        try { window.lenis.scrollTo(target, { duration: 0.6, force: true }); } catch(_){}
      }
      try { window.scrollTo({ top: target, behavior: 'smooth' }); } catch(_){}
      try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(_){}
    };
    doScroll();
    [120, 400, 800].forEach(d => setTimeout(() => {
      const stillOff = Math.abs(el.getBoundingClientRect().top) > 40;
      if (stillOff) doScroll();
    }, d));
  }
  function imgFail(img){ img.style.display='none'; const p=img.parentNode; if(p) p.classList.add('noimg'); }
  function phoneEl(){ return document.getElementById('scalc-phone'); }

  // ── Validation + step navigation ─────────────────────────────────────────
  function paneValid(n){
    switch(n){
      case 1: return state.qty>0;
      case 2: return !!state.tier;                 // Design — defaults to suite
      case 3: return !!state.style
                  && (state.style!=='presswork' || !!state.method)
                  && state.qty>=minQty();
      default: return true;
    }
  }
  function validate(){
    const last = state.step===STEPS.length;
    $('nextBtn').disabled = !paneValid(state.step);
    $('nextBtn').textContent = last ? 'Pay Design Fee & start design' : 'Continue';
    $('nextBtn').classList.toggle('scalc-deposit-cta', last);
    // Inline Continue on step 1 turns solid red once a quantity is entered.
    const s1 = document.querySelector('.dc-step1-next'); if(s1) s1.classList.toggle('is-ready', paneValid(1));
  }
  function renderStep(){
    setNextHot(false);   // reset the maroon cue each step
    document.querySelectorAll('.std-calc .scalc-pane').forEach(p=>p.classList.toggle('active', +p.dataset.step===state.step));
    $('stepNum').textContent = ROMAN[state.step-1];
    $('stepName').textContent = STEPS[state.step-1];
    $('progFill').style.width = (state.step/STEPS.length*100)+'%';
    $('backBtn').disabled = state.step===1;
    if (!firstRender) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const calcEl = document.querySelector('.std-calc');
          if (calcEl) scrollToCalcTop(calcEl);
        });
      });
    }
    firstRender = false;
    validate(); recalc();
    if(state.step===1) setTimeout(()=>$('qtyIn').focus({preventScroll:true}), 350);
    // On the Design step, cue the Continue button after a beat (no scroll there).
    if(state.step===2) setTimeout(()=>{ if(state.step===2) setNextHot(true); }, 300);
  }
  function go(dir){
    if(dir>0 && state.step===STEPS.length){ addToCart(); return; }
    if(dir>0 && !paneValid(state.step)) return;
    state.step = Math.min(STEPS.length, Math.max(1, state.step+dir));
    renderStep();
  }
  function goTo(n){ state.step = n; renderStep(); }

  // ── Selectors ────────────────────────────────────────────────────────────
  function setStyle(s){
    const btn = document.querySelector(`[data-style="${s}"]`);
    if(btn && btn.disabled) return;
    state.style = s;
    if(s!=='presswork') state.method = null;
    document.querySelectorAll('[data-style]').forEach(b=>b.classList.toggle('on', b.dataset.style===s));
    document.querySelectorAll('[data-method]').forEach(b=>b.classList.remove('on'));
    if(s==='digital') clearFinChecks(['digital']);
    else if(s==='presswork') clearFinChecks([]);   // method selection sets its group
    else if(s==='acrylic') clearFinChecks(['acrylic']);
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext(state.style==='presswork' ? $('methodGroup') : (state.style==='acrylic' ? $('acSizeGroup') : $('finDigital')));
  }
  function setMethod(m){
    state.method = m;
    document.querySelectorAll('[data-method]').forEach(b=>b.classList.toggle('on', b.dataset.method===m));
    clearFinChecks([m]);
    refreshReveal(); updateQtyUI(); recalc(); validate();
    scrollToNext(pressFin());
  }
  function setAcSize(s){
    state.acSize = s;
    document.querySelectorAll('[data-acsize]').forEach(b=>b.classList.toggle('on', b.dataset.acsize===s));
    recalc();
    scrollToNext($('finAcrylic'));
  }
  function setTier(t){
    state.tier = t;
    document.querySelectorAll('[data-tier]').forEach(b=>b.classList.toggle('on', b.dataset.tier===t));
    updateTierHint();
    recalc(); validate();
    // No scroll on the Design step — cue the Continue button (turns maroon) instead.
    setNextHot(true);
  }
  // Turn the floating Continue button maroon to signal the next move (used on the
  // Design step, where we deliberately don't scroll). Reset on every step change.
  function setNextHot(on){
    const n = $('nextBtn'); if(!n) return;
    if(on){
      n.style.setProperty('background','#7a1c1a','important');
      n.style.setProperty('border-color','#7a1c1a','important');
      n.style.setProperty('color','#fff','important');
    } else {
      n.style.removeProperty('background');
      n.style.removeProperty('border-color');
      n.style.removeProperty('color');
    }
  }
  function updateTierHint(){
    const h = $('tierHint'); if(!h) return;
    h.textContent = state.tier==='indiv'
      ? `Tailored Touch — fully personalised design. Design fee ${fmt0(designBaseFor())}.`
      : `Studio Collection — refined semi-custom design. Design fee ${fmt0(designBaseFor())}.`;
  }
  function chk(k,on){
    state.checks[k] = !!on;
    // Matching-design upsell is single-choice: invDesign XOR fullDesign.
    if(on && (k==='invDesign' || k==='fullDesign')){
      const other = k==='invDesign' ? 'fullDesign' : 'invDesign';
      if(state.checks[other]){
        state.checks[other] = false;
        const cb = document.querySelector('[data-c="'+other+'"]'); if(cb) cb.checked = false;
      }
    }
    recalc();
  }
  function setRibbon(v){ state.ribbon = v; document.querySelectorAll('[data-rb]').forEach(b=>b.classList.toggle('on', b.dataset.rb===v)); recalc(); }
  function setSeal(v){
    state.seal = v;
    document.querySelectorAll('[data-seal]').forEach(b=>{ const on = b.dataset.seal===v; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    const sub = $('waxType'); if(sub) sub.hidden = v!=='wax';
    recalc();
  }
  function setWax(v){ state.waxType = v; document.querySelectorAll('[data-wt]').forEach(b=>b.classList.toggle('on', b.dataset.wt===v)); recalc(); }
  function setPay(m){ state.pay = m; document.querySelectorAll('[data-pay]').forEach(b=>b.classList.toggle('on', b.dataset.pay===m)); recalc(); validate(); }
  function togTile(key){
    state.checks[key] = !state.checks[key];
    const el = document.querySelector(`[data-tile="${key}"]`);
    if(el){ el.classList.toggle('on', state.checks[key]); el.setAttribute('aria-pressed', state.checks[key]); }
    recalc();
  }

  // ── Add to cart (deposit -> native cart -> checkout) ──────────────────────
  function gidToNumeric(gid){ if(!gid) return null; const m = String(gid).match(/(\d+)$/); return m ? m[1] : null; }
  function prettyPrint(s){
    if(s.style==='acrylic') return 'Acrylic';
    if(s.style==='digital') return 'Fine Digital';
    if(s.style==='presswork') return ({letterpress:'Letterpress', hotfoil:'Hot Foil', embossed:'Embossing'}[s.method]) || 'Luxury Presswork';
    return '—';
  }
  function capitalize(str){ return str ? str[0].toUpperCase()+str.slice(1) : ''; }
  function prettyAddOns(cc){
    const labels = {
      foilS:'Foil front', duplex:'Duplexing',
      lp2pms:'Letterpress 2-PMS', lpFoil:'LP + Hot foil',
      hfDigital:'HF + Digital', hfLp:'HF + Letterpress',
      emLp:'Embossed + LP', emHf:'Embossed + Foil',
      acMirror:'Mirror acrylic',
      cut:'Custom cut to shape',
      envUp:'Premium envelope', envAddr:'Guest addressing', envLiner:'Envelope liner', envEmb:'Envelope embossing',
      magnets:'Magnet backing (free)'
    };
    return Object.keys(cc).filter(k=>cc[k] && labels[k]).map(k=>labels[k]).join(', ');
  }

  async function addToCart(){
    const btn = document.querySelector('.dc-cta') || $('nextBtn');
    if(!state.qty || !state.style){ showError('Please complete your save the date selections.'); return; }
    if(!window.FelDesign){ showError('Sorry — the order helper did not load. Please refresh and try again.'); return; }

    const originalText = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }

    const prioChk = $('prioChk');
    // The $0 Print Configuration line carries every print spec for later invoicing.
    const printProps = {
      'Product': 'Save the Dates',
      '_edit_url': (typeof location !== 'undefined' ? location.pathname : ''),
      'Quantity': String(state.qty),
      'Digital save the dates (free)': state.checks.digitalSTD ? 'Yes' : 'No',
      'Print method': prettyPrint(state),
      'Acrylic size': state.style==='acrylic' ? acSizeLabel(state.acSize) : '',
      'Custom cut': state.checks.cut ? 'Yes' : 'No',
      'Ribbon': state.checks.ribbon ? capitalize(state.ribbon) : 'None',
      'Seal': state.seal==='wax'
        ? ('Custom wax — ' + (state.waxType==='adhesive' ? 'adhesive' : 'sticks'))
        : 'Sticker (complimentary)',
      'Magnet backing (free)': state.checks.magnets ? 'Yes' : 'No',
      'Priority Studio Service': (prioChk && prioChk.checked) ? 'Quote requested' : 'No',
      'Add-ons': prettyAddOns(state.checks),
      'Estimated production balance (AUD)': fmt(printTotal()),
      // Hidden from the customer cart (key starts with "_") but visible to the
      // merchant on the order in Shopify Admin — full itemised print breakdown.
      '_print breakdown': lines().filter(([,,st])=> st===3 || st===4).map(([l,p])=>`${l} — ${fmt(p)}`).join(' | '),
      'Full estimate (AUD)': fmt(printTotal() + designFeeAmt())
    };
    const STD_HIDE = new Set(['No', 'None', '0', '']);
    Object.keys(printProps).forEach(k => { if (!printProps[k] || STD_HIDE.has(printProps[k])) delete printProps[k]; });

    const designProps = { 'Booked from': 'Save the Dates page', 'Save the Dates quantity': String(state.qty) };

    try {
      // Reconcile the scope-tiered design fee across the cart (charged once) and add
      // this product's $0 print line; helper redirects to /cart on success.
      await window.FelDesign.checkout({
        tier: designTierKey(),
        scope: designScopeKey(),
        printKey: 'std',
        printProps: printProps,
        designProps: designProps,
        redirect: true
      });
    } catch(err){
      console.error('[STDCalc.addToCart]', err);
      showError('Sorry, something went wrong: ' + (err.message || 'unknown') + ' — email info@felicitations.com.au');
      if(btn){ btn.disabled = false; btn.textContent = originalText; }
    }
  }

  function updateHeaderOffset(){
    const headerEl = document.querySelector('header[is="sticky-header"], sticky-header, custom-header, .site-header, .header__wrapper, .shopify-section-header');
    const computed = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--scalc-header-offset', computed + 'px');
  }
  function setupBarVisibility(){
    const calc = document.querySelector('.std-calc');
    const bar  = document.querySelector('.std-calc .studio-calc-bar');
    if(!calc || !bar) return;
    if(!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries)=>{
      bar.classList.toggle('scalc-hidden', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(calc);
  }
  function hideInlineCTAs(){
    const calc = document.querySelector('.std-calc');
    if (!calc) return;
    const isInsideFloatingBar = el => !!el.closest('product-sticky-form, .product-sticky-form, .product-sticky-form__card');
    document.querySelectorAll('a, button').forEach(el => {
      const text = (el.textContent || '').trim().toLowerCase();
      if (!text) return;
      if (text === 'secure your spot' || text === 'secure your deposit' ||
          text.startsWith('secure your spot') || text.startsWith('secure your deposit')) {
        if (isInsideFloatingBar(el)) return;
        el.style.setProperty('display', 'none', 'important');
      }
    });
    document.querySelectorAll('a, p, span, div, button, h1, h2, h3, h4, h5, h6').forEach(el => {
      if (isInsideFloatingBar(el)) return;
      if (el.closest('.std-calc')) return;
      const txt = (el.textContent || '').trim().toLowerCase();
      if (!txt || txt.length > 80) return;
      if (txt.includes('check your investment') || txt.includes('see your investment') || txt.includes('your investment estimate')) {
        el.style.setProperty('display', 'none', 'important');
        const p = el.parentElement;
        if (p && p.children.length <= 2) p.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function setupThemeStickyHide(){
    const calc = document.querySelector('.std-calc');
    if (!calc) return;
    if (!('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => {
      const calcInView = entries[0].isIntersecting;
      document.querySelectorAll('product-sticky-form, .product-sticky-form').forEach(bar => {
        if (calcInView) {
          bar.dataset.stdHidPrev = bar.style.display || '';
          bar.style.setProperty('display', 'none', 'important');
        } else if (bar.dataset.stdHidPrev !== undefined) {
          bar.style.display = bar.dataset.stdHidPrev;
          delete bar.dataset.stdHidPrev;
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    obs.observe(calc);
  }
  function showError(msg){
    let el = $('std-err');
    if(!el){
      el = document.createElement('p');
      el.id = 'std-err';
      el.className = 'err';
      const rev = $('rev'); if(rev && rev.parentNode) rev.parentNode.appendChild(el);
    }
    el.textContent = msg;
  }

  // ── Tile rendering (Hidden Details + Seals) ──────────────────────────────
  function buildTiles(){
    const hidden = $('hiddenTiles');
    if(hidden){
      hidden.innerHTML =
        `<button type="button" class="scalc-tile" data-tile="envLiner" data-tile-action="toggle" aria-pressed="false">
           <div class="img"><img src="${ICON.liner}" alt="Envelope Liner" data-img-onerror="1"></div>
           <div class="nm">Envelope Liner</div>
           <div class="pr"><span data-tileprice="liner"></span></div>
         </button>
         <button type="button" class="scalc-tile" data-tile="envEmb" data-tile-action="toggle" aria-pressed="false">
           <div class="img"><img src="${ICON.emboss}" alt="Envelope Embossing" data-img-onerror="1"></div>
           <div class="nm">Envelope Embossing</div>
           <div class="pr"><span data-tileprice="emboss"></span></div>
         </button>`;
    }
    const seal = $('sealTiles');
    if(seal){
      seal.innerHTML =
        `<button type="button" class="scalc-tile on" data-seal="sticker" aria-pressed="true">
           <div class="img"><img src="${ICON.sticker}" alt="Sticker Seal" data-img-onerror="1"></div>
           <div class="nm">Sticker Seal</div>
           <div class="pr" style="color:#7a1c1a">Included free</div>
         </button>` +
        `<button type="button" class="scalc-tile" data-seal="wax" aria-pressed="false">
           <div class="img"><img src="${ICON.wax}" alt="Custom Wax Seal" data-img-onerror="1"></div>
           <div class="nm">Custom Wax Seal</div>
           <div class="pr">$195 + per piece</div>
         </button>` +
        `<div class="scalc-sub-opts brk" id="waxType" hidden>
           <button type="button" class="scalc-opt on" data-wt="adhesive">Adhesive +$5.50/ea</button>
           <button type="button" class="scalc-opt" data-wt="stick">DIY sticks +$9.50</button>
         </div>`;
    }
  }

  // ── Process info popup ────────────────────────────────────────────────────
  // Tailored Touch gets a longer process (5 business days / 4 revision rounds);
  // Studio Collection is 3 days / 2 rounds. Swap the inline numbers on open.
  function updateInfoPopup(){
    const isTT = state.tier === 'indiv';
    const d = document.querySelector('.scalc-info-days');   if(d) d.textContent = isTT ? 'five' : 'three';
    const r = document.querySelector('.scalc-info-rounds'); if(r) r.textContent = isTT ? 'four' : 'two';
  }
  function openInfo(){ updateInfoPopup(); const m = $('scalcInfo'); if(m){ m.hidden = false; try{ document.documentElement.style.overflow='hidden'; }catch(e){} } }
  function closeInfo(){ const m = $('scalcInfo'); if(m){ m.hidden = true; try{ document.documentElement.style.overflow=''; }catch(e){} } }

  // ── Event wiring (delegated) ──────────────────────────────────────────────
  function wireEvents(root){
    root.addEventListener('error', (e)=>{
      const t = e.target;
      if(t && t.tagName === 'IMG' && t.dataset.imgOnerror) imgFail(t);
    }, true);

    root.addEventListener('click', (e)=>{
      const t = e.target.closest('[data-action], [data-tier], [data-style], [data-method], [data-acsize], [data-tile-action], [data-seal], [data-rb], [data-wt], [data-pay], .scalc-chip, .scalc-stepper, .scalc-skip');
      if(!t) return;
      const ds = t.dataset;
      if(ds.action === 'go'){ go(parseInt(ds.dir,10)); return; }
      if(ds.action === 'bump'){ bump(parseInt(ds.amt,10)); return; }
      if(ds.action === 'infoOpen'){ openInfo(); return; }
      if(ds.action === 'infoClose'){ closeInfo(); return; }
      if(t.classList.contains('scalc-chip')){ pick(+ds.q); return; }
      if(t.classList.contains('scalc-skip')){ go(1); return; }
      if(ds.tier){    setTier(ds.tier);     return; }
      if(ds.style){   setStyle(ds.style);   return; }
      if(ds.method){  setMethod(ds.method); return; }
      if(ds.acsize){  setAcSize(ds.acsize); return; }
      if(ds.tileAction === 'toggle'){ togTile(ds.tile); return; }
      if(ds.seal){ setSeal(ds.seal); return; }
      if(ds.rb){   setRibbon(ds.rb); return; }
      if(ds.wt){   setWax(ds.wt);   return; }
      if(ds.pay){  setPay(ds.pay); addToCart(); return; }
    });

    root.addEventListener('change', (e)=>{
      const t = e.target;
      if(t.matches('[data-c]')){
        chk(t.dataset.c, t.checked);
        if(t.dataset.c==='ribbon'){ const sub = $('ribbonType'); if(sub) sub.hidden = !t.checked; }
        return;
      }
      if(t.id === 'addrSel'){ chk('envAddr', +t.value===1); return; }
    });
    root.addEventListener('input', (e)=>{
      if(e.target.id === 'qtyIn') onQty(e.target.value);
    });
    document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') closeInfo(); });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function readCfg(rootEl){
    const d = rootEl.dataset;
    cfg.designBase = parseFloat(d.designBase) || 100;
    cfg.deposit    = parseFloat(d.depositAmount) || 100;
    { const tu = parseFloat(d.tierUpcharge); cfg.tierUpcharge = isNaN(tu) ? 50 : tu; }
    cfg.depositVariantGid = d.depositVariantId || '';
    cfg.fullVariantGid    = d.fullVariantId    || '';
    cfg.tierAddonVariantGid = d.tierAddonVariantId || '';
    { const mi = parseFloat(d.matchInvAmount);  cfg.matchInvAmount  = isNaN(mi) ? 100 : mi; }
    cfg.matchInvVariantGid  = d.matchInvVariantId  || '';
    { const mf = parseFloat(d.matchFullAmount); cfg.matchFullAmount = isNaN(mf) ? 200 : mf; }
    cfg.matchFullVariantGid = d.matchFullVariantId || '';
    { const mit = parseFloat(d.matchInvAmountTt);  cfg.matchInvAmountTT  = isNaN(mit) ? 150 : mit; }
    cfg.matchInvVariantGidTT  = d.matchInvVariantIdTt  || '';
    { const mft = parseFloat(d.matchFullAmountTt); cfg.matchFullAmountTT = isNaN(mft) ? 350 : mft; }
    cfg.matchFullVariantGidTT = d.matchFullVariantIdTt || '';
    cfg.designName = d.designName || 'Save The Dates';
    const depBtn = document.querySelector('[data-pay="deposit"]');
    if(depBtn) depBtn.firstChild.nodeValue = `Pay Design Fee · $${cfg.deposit}`;
  }

  function init(){
    const root = document.querySelector('.std-calc');
    if(!root) return;

    if (firstRender) {
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(_){}
      try {
        const navType = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]?.type)
          || (performance.navigation && performance.navigation.type === 0 ? 'navigate' : 'other');
        if (navType === 'navigate' || navType === 'reload') {
          if (location.hash && /std|calc|scalc/i.test(location.hash)) {
            history.replaceState(null, '', location.pathname + location.search);
          }
          const forceTop = () => {
            try { window.lenis && window.lenis.scrollTo && window.lenis.scrollTo(0, { immediate: true, force: true, lock: true }); } catch(_){}
            try { window.scrollTo(0, 0); } catch(_){}
            try { document.documentElement.scrollTop = 0; } catch(_){}
            try { document.body && (document.body.scrollTop = 0); } catch(_){}
          };
          forceTop();
          [0, 50, 150, 350, 700].forEach(d => setTimeout(forceTop, d));
        }
      } catch(_){}
    }

    readCfg(root);
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset, { passive: true });
    const chips = $('chips');
    if(chips){
      [30,50,80,100,120].forEach(q=>{
        const c = document.createElement('button');
        c.type = 'button';
        c.className = 'scalc-chip';
        c.dataset.q = q;
        c.textContent = q;
        chips.appendChild(c);
      });
    }
    buildTiles();
    wireEvents(root);
    setupBarVisibility();
    hideInlineCTAs();
    setupThemeStickyHide();

    let welcomeTs = null;
    const loaded = stdLoad();
    if(loaded && loaded.data){
      Object.assign(state, loaded.data);
      if(!state.checks) state.checks = {};
      state.pay = 'deposit';
      if(stdHasMeaningful()){
        stdApplyRestoredUI();
        welcomeTs = loaded.ts;
      }
    }

    updateTierHint();
    refreshReveal();
    renderStep();
    if(welcomeTs) stdShowWelcome(welcomeTs);
  }

  window.STDCalc = { go, goTo, bump, pick, addToCart, init };

  function safeInit(){
    try {
      if (document.querySelector('.std-calc')) init();
    } catch(err){
      console.error('[STDCalc] init failed', err);
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeInit);
  else safeInit();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('.std-calc')) safeInit();
  });
})();
